import React from "react";
import { siteConfig } from "../constants";
import "./CoffeeTip.css";
import colors from "../theme/colors";
import { withAlpha } from "../theme/utils";

const CoffeeTip = ({ className = "" }) => {
  const btnStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 16px",
    background: `linear-gradient(135deg, ${colors.accentOrange} 0%, ${withAlpha(colors.accentBlue, 0.95)} 100%)`,
    color: colors.textPrimary,
    textDecoration: "none",
    borderRadius: "25px",
    fontSize: "14px",
    fontWeight: 600,
    transition: "all 0.2s ease",
    boxShadow: `0 2px 8px ${withAlpha(colors.accentOrange, 0.35)}`,
  };

  return (
    <a
      href={siteConfig.paypalCoffeeTip}
      target="_blank"
      rel="noopener noreferrer"
      className={`coffee-tip-btn ${className}`}
      title="Buy me a coffee ☕"
      style={btnStyle}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = `0 4px 12px ${withAlpha(colors.accentOrange, 0.45)}`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.boxShadow = `0 2px 8px ${withAlpha(colors.accentOrange, 0.35)}`;
      }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 8h1a4 4 0 0 1 0 8h-1"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line x1="6" y1="1" x2="6" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="10" y1="1" x2="10" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="14" y1="1" x2="14" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span>Buy Coffee ☕</span>
    </a>
  );
};

export default CoffeeTip;
